import { useRef, useEffect } from 'react';

export default function useUpdateEffect(
  effect: () => void | (() => void),
  dependencies: Array<any> = [],
) {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
